import { Box, Checkbox, Group, Text } from '@mantine/core';

import { NodeCard } from '@/app/workflows/components/v6/atoms/NodeCard';
import { OperationCardIcon } from './OperationCardIcon';
import { useSelectedObject } from '../hooks/useSelectedObject';
import { useHover } from '@mantine/hooks';

type OperationCardProps = {
  name: string;
  description: string;
  onClick?: () => void;
  isSelected: boolean;
  isEnabled?: boolean;
  path: string;
};

export function OperationCard({ name, description, onClick, isSelected, isEnabled = false, path }: OperationCardProps) {
  const { updatedSelectedObjects } = useSelectedObject();
  const { hovered, ref } = useHover();

  const isOptional = path !== 'export';

  return (
    <NodeCard
      onClick={onClick}
      w={320}
      stackProps={{ align: 'flex-start', 'data-testid': `operation-card-${path}` }}
      isSelected={isSelected}
    >
      <Group
        ref={ref}
        align='flex-start'
        py='xs'
        wrap='nowrap'
        gap='12'
        w='100%'
        px='25'
        flex='0 1'
        style={{ alignItems: 'center' }}
      >
        <Group
          justify='center'
          align='center'
          w={40}
          h={40}
          bg={isEnabled ? 'var(--mantine-color-teal-0)' : 'var(--mantine-color-gray-0)'}
          style={{ borderRadius: 4, flexShrink: 0 }}
        >
          <OperationCardIcon isEnabled={isEnabled} operationName={name} />
        </Group>
        <Group justify={isOptional ? 'space-between' : 'flex-start'} flex='1'>
          <Text fw={600}>{name}</Text>
          {isOptional && (
            <Checkbox
              checked={isEnabled}
              onChange={() => updatedSelectedObjects(path)}
              data-testid={`operation-checkbox-${path}`}
            />
          )}
        </Group>
      </Group>

      <Box
        px='md'
        style={{
          maxHeight: hovered ? 80 : 0,
          overflow: 'hidden',
          transition: 'max-height 0.3s ease',
        }}
      >
        <Text size='sm' color='gray.6'>
          {description}
        </Text>
      </Box>
    </NodeCard>
  );
}
